<template>
  <el-dialog :visible.sync="dialogVisible" width="400px" class="succss-modal" center>
    <div class="content">
      <div><i class="icon-submit" /><span class="submit-text">{{ $t('data.successfully_submit') }}</span></div>
      <p class="amount-text">{{ $t('data.cash_out')+ ' ' + $t('components.amount') }}：<span style="color:#3855F1">{{ $store.getters.currency }}  {{ amount | numWithDot }}</span></p>
      <div class="line" />
      <p class="tip">{{ $t('data.withdraw_success_tip') }}</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" class="btn-back" @click="dialogVisible = false">{{ $t('components.close') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Withdraw_Success_Modal',
  components: {
  },
  props: {
    withdrawNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      amount: 0,
      dialogVisible: false // 控制弹框显示隐藏
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value, data) {
      this.dialogVisible = value
      this.amount = data
    }

  }
}
</script>

<style>
.succss-modal .el-dialog__header{
  border-top: 4px solid #3855F1;
}
</style>

<style scoped lang="scss">
.succss-modal{
  box-shadow: 0px 58px 23px rgba(0, 0, 0, 0.01), 0px 33px 20px rgba(0, 0, 0, 0.05), 0px 14px 14px rgba(0, 0, 0, 0.09), 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
p{
  margin: 0;
}
.content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -25px;
  // padding: 0 28px;

}
.icon-submit{
  height: 30px;
  width: 30px ;
  display: inline-block;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATpSURBVHgB3ZtNbBtFFMf/b+K0KaSNI4F6a9MLiANNLK6EundQE0CiTalIL1yTXuGQ5ADXmCuXFpUkPQBNBfdsCddqHThU5ELCraJSnARVSbPe6byxnfhzvV/eXfsnRbbXK2t/ebOzb2beEDrE3R0zfRrIipS4KEmOQYL/0iCM1JwosaWObal3BduWG7YNwwLyt4czBXQAQoiw5EBKzCiLrPqYRTAMAq1Ky350YzizhZAIRfj+jplNpWgOwSVbYViWXLg1nDEQkEDCEYjWopo+kZi9/vrlR/CJL+GVHXMEKbqLqETrIdzDkVzw09QFPPJgf2NGyZqIS5aRmEY/rS3/v/EFPOI6wtwhnekTc6rHnUWCIKLc9cHRO67Pd3OS7n3Vf1Q/WpJJHpacdNPE2wrr+7UkO4Ikw8/yI3m1nbSjcNfIVlDSB0cy45S0OHda/fSwa2QZda0DKVrjW7DVKS2FH+xtLCb4nnVi7Ey/mGv1ZdMmvbRnTgvSz9muRdryztRQJld/vEG46+7b1hRUz52p78QamrTsw3wPyDLpcjZYQ02El3fMCUqpjqqnUI+qsyeDjpoIUz8touegmg7sOMLlkc8aEsj2s2fI/fQzXjs9gNlPP8Gb6SF44yTKxxEuD/MSB8t+e38Jzwu7+Jff/7iE/9R7b5y46QiXh3v/IGFUZF8cHtYcf2NoCF99ftNTpA8sOcwZmI6wFJhAwmglyzzf3dWR9sIpAT3K08Ik6BoShJNsBZb2ghB0hV+pNPFGO0gIbmSZj8fHMfnB+/ACN2uRQnLy5U7KMoOn+q4IIWKcqqmi07LMkVW8JNT9O4oAPN3expPNTQQhClmG+mg0RZxz+uSX9XU8/P0P/X788rv48qMP4ZWoZDVquCv8DhSqZZn1P//C97/+Bi9EKssQ0qJhrccF9bIVvEhHLsuo4Hqel2aayVZwIx2LbBlfwu9cvOD4vZN0nLKML2HunDifdaKZdNyyjNDrsx5h2a9v3fQknQRZvRi3vJ83yWe2xfnsNzx0a5PXvvf2W3i6tR2vbAlDQK26wyduI/3k780kyKpeWu7yPZxHANxKOxGJrMKWyItyfUUggkhHJcuocYMhDoswEAJ+pKOUZQ4sFeHywpOBEPAiHbWswjie4rFt+Rgh4UY6BlleetF1IVr4pY0cQsRJOg5Zhmys8qsWDrNZV2gmHZeswqisMR1PxK/sm1n1MfSJeE5K+Dl84fz5tjl45ziZiK9ZW1rZz7NwFr2ESp1vnBu7VPlYN3iQC+gxJGRNhU+NcDnsBnoFwr2pc5nV6kONw0NL3gYvJnc7Ulf1NLTYBmHuzdQzq+ubtlppmG9WwtR0AoBrI1Tb/w5dCl/7Z4OjPzT7ruWMx6GFeRlwJBUT+amzmZblkS2FORk5tORVPzMiscHXaslJp1Mc57R0BlbsEmm+xmL70sO2k3j6B9QPJbx55w+KjSVKzfBUIL68b+YINIMEwR0U9zduN4V4rohf2TOndc0E+VuiCQ2JghRyYWow42mk53sLABewEZHnivSQMDhB8rMFINAmj+U9c0I18cUIo21wvl9daOaVULbxlIeWHd3GE1S0QqgbtbipU0pcUx0JVwVlEQxDST5WE2+5MHephSpcTalYBmO2jawoVRmk9Vp0k614klAgQp4k5W1pb/NMaqe24r0CoAdwiqg1CBMAAAAASUVORK5CYII=');
  background-size: 100% 100%;
}
.submit-text{
  vertical-align: top;
  display: inline-block;
  margin-left: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 30px;
  color: #047857;
  font-family: 'Poppins-Medium';
}
.amount-text{
  margin-top: 32px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
}
.line{
  width: 294px ;
  height: 1px;
  margin: 16px auto;
  background: #B5BCC9;
}
.tip{
  padding: 0 28px;
  font-size: 12px;
  color: #7A869E;
  text-align: center;
}

.btn-back{
  margin-top: 16px;
  margin-bottom: 4px;
  width: 154px;
  height: 50px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 14px;
}
</style>
